export default __webpack_public_path__ + "static/media/icon_maintenance@2x.648f66ab.png";